import { useLocation, useMatch, useNavigate } from "react-router-dom";
import profile_placeholder from "../assets/images/profile_placeholder.png";
import { useState, useEffect, useContext, useRef, useCallback } from "react";
import henceforthApi from "../utils/henceforthApi";
import { GlobalContext } from "../context/Provider";
import Modal from "react-bootstrap/Modal";
import Post from "../UserActivity/Post";
import Chats from "../UserActivity/Chats";
import CoinHistory from "../UserActivity/CoinHistory";
import ViewActivityOfUser from "../UserActivity/ViewActivityOfUser";
import Stories from "../UserActivity/Stories";
import Reel from "../UserActivity/Reel";
import PaginationLayout from "../components/PaginationLayout";
import moment from "moment/moment";
import { getUserProfileImage } from "../utils/constant_value";

export default () => {
  const match = useMatch("/user/:id/:type/:page");
  const { authState, scrollToTop, handleError } = useContext(GlobalContext);
  const [userDetails, setUserDetails] = useState({
    _id: "",
    social_type: null,
    social_token: null,
    profile_pic: "fe",
    cover_image: null,
    full_name: "",
    email: "",
    new_email: null,
    username: "",
    country_code: null,
    phone_no: 0,
    new_phone_no: 0,
    new_country_code: null,
    email_otp: "",
    phone_otp: 0,
    account_type: "",
    gender: "",
    customer_id: null,
    bank_account_id: null,
    available_coins: 0,
    birthday: null,
    hobbies: [],
    is_blocked: false,
    is_deleted: false,
    is_email_verified: false,
    is_phone_verified: false,
    account_status: "",
    version: null,
    version_status: "",
    device_type: "",
    created_at: "",
  });
  const limit = 9
  henceforthApi.setToken(authState.access_token);
  const [loading, setLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(0)
  const [data, setData] = useState()
  const [page, setPage] = useState(1)
  const location = useLocation()
  const urlSearchParams = new URLSearchParams(location.search)
  //userActivity of User
  //  const userDetailsFunction=async()=>{
  //   let apiRes = await henceforthApi.User.getUserDetailsPosts(
  //     match?.params?.id,
  //     Number(page),
  //     Number(9)
  //   );
  //   setGetUserPosts(apiRes);
  //  }
  //userDetailsPost
  const navigate = useNavigate()
  const [getUserPosts, setGetUserPosts] = useState([]);
  const [getActivity, setGetActivity] = useState([]);
  const mediaType = (type, query) => {
    navigate(`/user/${match.params.id}/${type}/1?type=${query}`)
  }
  // const viewActivity = useRef(null)

  const onChangePagination = (newVal) => {
    navigate(`/user/${match.params.id}/${match.params.type}/${newVal}?type=${urlSearchParams.get("type")}`)
    // setPage(Number(newVal))
  };
  const userDetailsPost = async (type, activity_type) => {
    // if (match.params.type == 4) {
    //   console.log('chla');
    //   viewActivity.current?.click()
    //   // document.getElementById("activity").click()
    //   // navigate(`/user/${match.params.id}/1/1`)
    // }
    // console.log(activity_type, "activity_type");
    try {
      setLoading(true);
      let apiRes = await henceforthApi.User.getUserDetailsPosts(
        match?.params?.id,
        match.params.type,
        Number(match.params.page - 1),
        limit
      );
      setGetUserPosts(apiRes);
      setTotalCount(apiRes?.count)
      setLoading(false);
      // setGetUserPosts(apiRes)
      // if(type == 1){
      //    setGetUserPosts(apiRes);
      //    navigate(`/user/${match.params.id}/${activity_type}`)
      //    setTotalCount(apiRes?.count)
      //    }
      //  else  if(type == 2){
      //       setGetReels(apiRes?.data);
      //       navigate(`/user/${match.params.id}/${activity_type}`)
      //     }
      //     else  if(type == 3){
      //       setGetStory(apiRes?.data);
      //       navigate(`/user/${match.params.id}/${activity_type}`)
      //     }
      //     else  if(type == 4){
      //       setGetActivity(apiRes?.data);
      //       navigate(`/user/${match.params.id}/${activity_type}`)
      //     }
      //       setLoading(false);
      //       setData(apiRes?.data)
      //  setTotalCount(apiRes?.data?.length)
    } catch (error) {
      handleError(error)
      setLoading(false)
    }
  }
  // setGetUserPosts(apiRes);


  //userDetailReels
  const [getReels, setGetReels] = useState([]);
  const userDetailReels = async (_id) => {
    let apiRes = await henceforthApi?.User?.getUserDetailsReels(
      match?.params?.id,
      _id

    );
    setGetReels(apiRes?.data);
  };
  // console.log(getReels,"getReels")
  //userDetailStory
  const [getStory, setGetStory] = useState([]);
  const userDetailStory = async (_id) => {
    let apiRes = await henceforthApi?.User?.getUserDetailsStory(
      match?.params?.id,
      _id
    );
    setGetStory(apiRes?.data);
  };

  //userChatListing
  const [getChatListing, setGetChatListing] = useState([]);
  const userDetailsChatListing = async () => {
    let apiRes = await henceforthApi?.User?.getUserChatListing(
      match?.params?.id,
      getChatListing?._id
    );
    setGetChatListing(apiRes?.data);
  }

  const [, pageType] = location.search.split("=")


  useEffect(() => {
    //  userDetailsCoinHistorySend();
    userDetailsPost();
    // userDetailsFunction()
    // userDetailStory();
    // userDetailReels();
    // userDetailActivity()
    // userDetailsChatListing();
    scrollToTop();
    if (pageType === 'chats') {
      userDetailsChatListing(userDetails._id)
    }
  }, [match?.params?.id, match?.params?.type, match.params.page, pageType]);
  const [showImage, setShowImage] = useState();

  const handleShow = () => {
    setShowImage(true)
  }
  const [showCover, setShowCover] = useState();

  const handleShowCover = () => {
    setShowCover(true)
  }
  return (
    <>
      <div className="row animated fadeInRight">
        <div className="col-md-12" style={{ color: "#000000" }}>
          <div className="ibox">
            <div className="ibox-title">
              <h5 style={{ fontSize: "16px" }}>User Details</h5>
            </div>
            <div className="col-sm-12">
              <Modal
                show={showImage}
                onHide={() => setShowImage(false)}
                backdrop="static"
                keyboard={false}
                centered
                className="confirm-box-modal"
              >
                <Modal.Header closeButton>
                  {getUserPosts?.user?.full_name}
                </Modal.Header>
                <Modal.Body closeButton>
                  <img
                    src={getUserProfileImage(getUserPosts?.user?.profile_pic)}
                    alt="ProfileImage"
                    className="ZoomImage "
                  />
                </Modal.Body>
              </Modal>
              {/* COver Image modal */}
              <Modal
                show={showCover}
                onHide={() => setShowCover(false)}
                backdrop="static"
                keyboard={false}
                centered
                className="confirm-box-modal"
              >
                <Modal.Header closeButton>
                  {getUserPosts?.user?.full_name}
                </Modal.Header>
                <Modal.Body closeButton>
                  <img
                    src={
                      getUserPosts?.user?.cover_image
                        ? `${henceforthApi?.API_FILE_ROOT_ORIGINAL}${getUserPosts?.user?.cover_image}`
                        : profile_placeholder
                    }
                    alt="ProfileImage"
                    className="ZoomImage"
                  />
                </Modal.Body>
              </Modal>
            </div>
            <div className="ibox-content">
              <div className="text-center">
                <div className="row">
                  <div className="col-md-12">
                    <img className="CoverImage "
                      onClick={() => handleShowCover(getUserPosts?.user?.cover_image)}
                      src={
                        getUserPosts?.user?.cover_image
                          ? `${henceforthApi?.API_FILE_ROOT_ORIGINAL}${getUserPosts?.user?.cover_image}`
                          : profile_placeholder
                      } alt="" />
                  </div>
                </div>
                <div className="row align-item-center">
                  {/* col-4  */}
                  <div className="col-md-4 position-relative">
                    <div className="DetailsProfileImage text-center">
                      <img
                        onClick={() => handleShow(getUserPosts?.user?.profile_pic)}
                        // src={
                        //   getUserPosts?.user?.profile_pic
                        //     ? `${henceforthApi?.API_FILE_ROOT_ORIGINAL}${getUserPosts?.user?.profile_pic}`
                        //     : profile_placeholder
                        // }
                        src={getUserProfileImage(getUserPosts?.user?.profile_pic)}

                        alt="ProfileImage"
                        className="detail-img d-flex align-items-center"
                      /> <div className="d-flex justify-content-center mr-auto mt-3">
                        <div className="">
                          <label style={{ fontSize: "12px", color: "#5E5E5E" }}>
                            Followers
                          </label>
                          <br></br>
                          <text style={{ fontSize: "16px", color: "#000" }}>
                            {getUserPosts?.user?.followers}
                          </text>
                        </div>
                        <div className="ms-4">
                          <label style={{ fontSize: "12px", color: "#5E5E5E" }}>
                            Following
                          </label>
                          <br></br>
                          <text style={{ fontSize: "16px", color: "#000" }}>
                            {getUserPosts?.user?.following}
                          </text>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* col-8  */}
                  <div className="col-md-8 py-4">
                    <div className="row">
                      <div className="col-8" style={{ textAlign: "left" }}>
                        {/* <div className="UsernameDetailsSpacing">
                          <label style={{ fontSize: "12px", color: "#5E5E5E" }}>
                            User Id
                          </label>
                          <br></br>
                          <text style={{ fontSize: "16px", color: "#000" }}>
                            {getUserPosts?.user?._id}
                          </text>
                        </div> */}
                        <div className="UsernameDetailsSpacing">
                          <label style={{ fontSize: "12px", color: "#5E5E5E" }}>
                            Name
                          </label>
                          <br></br>
                          <text style={{ fontSize: "16px", color: "#000" }}>
                            {getUserPosts?.user?.full_name}
                          </text>
                        </div>
                        <div className="UsernameDetailsSpacing">
                          <label style={{ fontSize: "12px", color: "#5E5E5E" }}>
                            Email
                          </label>
                          <br></br>
                          <text style={{ fontSize: "16px", color: "#000" }}>
                            {getUserPosts?.user?.email}
                          </text>
                        </div>
                        <div className="hobbies-box">
                          <label style={{ fontSize: "12px", color: "#5E5E5E" }}>
                            Hobbies
                          </label>
                          <ul className="list unstyled d-flex ps-0 mb-0 gap-1 hobbies-box-text">
                            {getUserPosts?.user?.hobbies.length > 0 ? getUserPosts?.user?.hobbies?.map((res) => (
                              <li style={{ fontSize: "16px", color: "#000" }}>{res}</li>
                            )) : "--"}
                          </ul>

                        </div>
                      </div>
                      <div
                        className="col-4 messageDeatilscol8"
                        style={{ textAlign: "left", color: "" }}
                      >
                        <div className="UsernameDetailsSpacing">
                          <label style={{ fontSize: "12px", color: "#5E5E5E" }}>
                            UserName
                          </label>
                          <br></br>
                          <text style={{ fontSize: "16px", color: "#000" }}>
                            {getUserPosts?.user?.username}
                          </text>
                        </div>
                        <div className="UsernameDetailsSpacing">
                          <label style={{ fontSize: "12px", color: "#5E5E5E" }}>
                            Phone
                          </label>
                          <br></br>
                          <text style={{ fontSize: "16px", color: "#000" }}>
                            {getUserPosts?.user?.country_code && getUserPosts?.user?.phone_no ? "+" + getUserPosts?.user?.country_code + " " + getUserPosts?.user?.phone_no : "--"}
                          </text>
                        </div>
                        <div className="UsernameDetailsSpacing">
                          <label style={{ fontSize: "12px", color: "#5E5E5E" }}>
                            Birthday
                          </label>
                          <br></br>
                          <text style={{ fontSize: "16px", color: "#000" }}>
                            {getUserPosts?.user?.birthday
                              ? moment(Number(getUserPosts.user.birthday)).format("DD MMM YYYY")
                              : "--"}
                          </text>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* {getUserPosts?.user?.hobbies?.map((res) => (
                    <div className="col-sm-12">{res}</div>
                  ))} */}
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
      {/* {loading ? <Spinner/> : */}
      <div className="row">
        <div className="col-md-12">
          <div className="ibox animated fadeInRight">
            <div className="ibox-title">
              <div className="title-head d-flex justify-content-between align-items-center flex-row">
                <h5>Users Activity </h5>

                <ul className="nav nav-tabs" id="myTab" role="tablist">
                  <li className="nav-item" >
                    <button
                      className={`nav-link ${pageType === 'posts' ? "active" : ""}`}
                      id="post-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#post"
                      type="button"
                      role="tab"
                      aria-controls="post"
                      aria-selected="true"
                      onClick={() => mediaType(1, "posts")}
                    >
                      Posts
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className={`nav-link ${pageType === 'stories' ? "active" : ""}`}
                      id="reel-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#reel"
                      type="button"
                      role="tab"
                      aria-controls="reel"
                      aria-selected="false"
                      onClick={() => mediaType(3, "stories")}
                    >
                      Stories
                    </button>
                  </li>
                  {/* <li className="nav-item" role="presentation">
                    <button
                      className={`nav-link ${pageType === 'reels' ? "active" : ""}`}
                      id="stories-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#stories"
                      type="button"
                      role="tab"
                      aria-controls="stories"
                      aria-selected="false"
                      onClick={() => mediaType(2, "reels")}
                    >
                      Reels
                    </button>
                  </li> */}
                  {/* <li className="nav-item" role="presentation">
                    <button
                      className={`nav-link ${pageType === 'chats' ? "active" : ""}`}
                      id="chat-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#chat"
                      type="button"
                      role="tab"
                      aria-controls="chat"
                      aria-selected="true"
                      onClick={() => { userDetailsChatListing(userDetails._id); mediaType(5, "chats") }}
                    >
                      Chats
                    </button>
                  </li> */}
                  {/* <li className="nav-item" role="presentation">
                    <button
                      className={`nav-link ${pageType==='coins_history' ? "active" : ""}`}
                      id="coin-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#coin"
                      type="button"
                      role="tab"
                      aria-controls="coin"
                      aria-selected="false"
                      onClick={() =>
                        userDetailsCoinHistorySend(userDetails._id)
                        mediaType(6, "coins_history")
                      }
                    >
                      Coins History
                    </button>
                  </li> */}
                  <li className="nav-item" role="presentation">
                    <button
                      className={`nav-link ${pageType === 'users' ? "active" : ""}`}
                      id="activity-tab"
                      // ref={viewActivity}
                      data-bs-toggle="tab"
                      data-bs-target="#activity"
                      type="button"
                      role="tab"
                      aria-controls="activity"
                      aria-selected="false"
                      onClick={() => mediaType(4, "users")}
                    >
                      View Activity of Users
                    </button>
                  </li>
                </ul>
              </div>
              <div className="tab-content" id="myTabContent">

                <div
                  className={`tab-pane fade ${pageType === 'posts' ? "show active" : ""}`}
                  id="post"
                  role="tabpanel"
                  aria-labelledby="post-tab"
                >
                  <Post getUserPosts={getUserPosts} userDetailsPost={userDetailsPost} />

                </div>
                <div
                  className={`tab-pane fade ${pageType === 'stories' ? "show active" : ""}`}
                  id="reel"
                  role="tabpanel"
                  aria-labelledby="reel-tab"
                >
                  <Stories getStory={getUserPosts} userDetailStory={userDetailsPost} />
                </div>
                <div
                  className={`tab-pane fade ${pageType === 'reels' ? "show active" : ""}`}
                  id="stories"
                  role="tabpanel"
                  aria-labelledby="stories-tab"
                >
                  {!loading && !getUserPosts?.data?.length ? <div className="text-center">No Reels Found</div> : <Reel getReels={getUserPosts} userDetailReels={userDetailsPost} />}
                </div>
                <div
                  className={`tab-pane fade ${pageType === 'chats' ? "show active" : ""}`}
                  id="chat"
                  role="tabpanel"
                  aria-labelledby="chat-tab"
                >
                  {!loading && !getChatListing.length ? <div className="text-center">No Chat Available</div> :
                    <div className="d-flex align-items-start chat-tabs">
                      <Chats
                        getChatListing={getChatListing}
                        getUserPosts={getUserPosts}
                      />
                    </div>}
                </div>
                <div
                  className={`tab-pane fade ${pageType === 'coins_history' ? "show active" : ""}`}
                  style={{ width: "100%" }}
                  id="coin"
                  role="tabpanel"
                  aria-labelledby="coin-tab"
                >
                  <CoinHistory userDetails={userDetails} />
                </div>

                <div
                  className={`tab-pane fade ${pageType === 'users' ? "show active" : ""}`}
                  id="activity"
                  role="tabpanel"
                  aria-labelledby="contact-tab"
                >
                  <ViewActivityOfUser loading={loading} getActivity={getUserPosts?.data} />
                </div>
              </div>
            </div>
            {(match.params.type == 1 || match.params.type == 2 || match.params.type == 3 || match.params.type == 4) ?
              <PaginationLayout
                count={totalCount}
                data={getUserPosts?.data}
                page={Number(match.params.page)}
                limit={Number(limit)}
                loading={loading}
                onPageChange={(val) => onChangePagination(val)}
              />
              : ""}
          </div>
        </div>
      </div>
      {/* } */}
    </>
  )
}
